// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Agreement Management Styles
   Based on Industrial Park Invoice CSS
   ============================================ */

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f5f5f5;
  color: #333;
}

.app {
  max-width: 1400px;
  margin: 0 auto;
  padding: 24px;
}

/* Header / Title */
.header {
  text-align: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #1976d2;
}

.header h1 {
  color: #1a365d;
  font-size: 28px;
}

/* Tabs – matches MUI Tab styling with custom hover */
.tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 30px;
  background: white;
  border-radius: 8px;
  padding: 10px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.tabs button {
  flex: 1 1;
  padding: 12px 20px;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  color: #666;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.tabs button:hover {
  background-color: #f0f0f0;
}

.tabs button.active {
  background-color: #1976d2;
  color: white;
}

/* Content panels */
.content {
  background: white;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.tab-content h2 {
  color: #1a365d;
  margin-bottom: 25px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

/* Form sections (Cards) */
.form-section {
  margin-bottom: 30px;
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background-color: #fafafa;
}

.form-section h3 {
  color: #1976d2;
  margin-bottom: 20px;
}

/* Grid layout helpers */
.form-row {
  display: flex;
  gap: 20px;
  margin-bottom: 15px;
}

.form-group {
  flex: 1 1;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: 600;
  color: #555;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #1976d2;
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.2);
}

/* Tables – used for items / room details */
.items-table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
}

.items-table th,
.items-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.items-table th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #495057;
}

.items-table tr:hover {
  background-color: #f8f9fa;
}

.items-table input[type="number"],
.items-table input[type="text"] {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

/* Totals section (used in invoice, may be reused) */
.total-section {
  text-align: right;
  margin-top: 20px;
  padding: 15px;
  background-color: #e3f2fd;
  border-radius: 6px;
}

.total-section h3,
.total-section h4 {
  color: #0d47a1;
  margin: 0;
}

/* Buttons */
.btn-primary {
  background-color: #1976d2;
  color: white;
  padding: 12px 30px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
  display: block;
  margin: 20px auto 0;
}

.btn-primary:hover {
  background-color: #1565c0;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.btn-secondary:hover {
  background-color: #5a6268;
}

/* Search section (Tab 2) */
.search-section {
  margin-bottom: 30px;
}

.search-box {
  display: flex;
  gap: 10px;
  align-items: center;
}

.search-box input {
  flex: 1 1;
}

/* Invoice / Agreement detail view */
.invoice-details {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 25px;
  background-color: #fff;
}

.invoice-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #1976d2;
}

.invoice-title {
  display: flex;
  align-items: center;
  gap: 15px;
}

/* Status badges */
.status-badge {
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.status-badge.pending {
  background-color: #fff3cd;
  color: #856404;
}

.status-badge.paid {
  background-color: #d4edda;
  color: #155724;
}

.status-badge.active {
  background-color: #cce5ff;
  color: #004085;
}

.status-badge.expired {
  background-color: #f8d7da;
  color: #721c24;
}

/* Payment table (if reused) */
.payment-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
}

.payment-table th,
.payment-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.payment-table th {
  background-color: #f8f9fa;
  font-weight: 600;
}

/* Totals labels */
.total-label {
  text-align: right;
  font-weight: 600;
  font-size: 16px;
}

.total-amount {
  font-weight: 700;
  font-size: 18px;
  color: #0d47a1;
}

/* Investor info block */
.investor-info p {
  margin-bottom: 8px;
  line-height: 1.5;
}

.investor-info strong {
  display: inline-block;
  width: 120px;
  color: #555;
}

/* Edit form animation */
.edit-form {
  animation: slideIn 0.3s ease;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
    gap: 15px;
  }
  
  .invoice-header {
    flex-direction: column;
    gap: 15px;
  }
  
  .search-box {
    flex-direction: column;
  }
  
  .tabs {
    flex-direction: column;
  }

  .app {
    padding: 12px;
  }
}

/* Chip customization */
.MuiChip-root {
  font-weight: 500;
}

/* Card hover effect */
.MuiCard-root {
  transition: box-shadow 0.3s ease;
}

.MuiCard-root:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}`, "",{"version":3,"sources":["webpack://./src/pages/Views/OperationAndManagement/Forms/agreement.css"],"names":[],"mappings":"AAAA;;;iDAGiD;;AAEjD;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,4DAA4D;EAC5D,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,2CAA2C;AAC3C;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,oDAAoD;AACpD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;AACxC","sourcesContent":["/* ============================================\r\n   Agreement Management Styles\r\n   Based on Industrial Park Invoice CSS\r\n   ============================================ */\r\n\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  background-color: #f5f5f5;\r\n  color: #333;\r\n}\r\n\r\n.app {\r\n  max-width: 1400px;\r\n  margin: 0 auto;\r\n  padding: 24px;\r\n}\r\n\r\n/* Header / Title */\r\n.header {\r\n  text-align: center;\r\n  margin-bottom: 30px;\r\n  padding-bottom: 20px;\r\n  border-bottom: 2px solid #1976d2;\r\n}\r\n\r\n.header h1 {\r\n  color: #1a365d;\r\n  font-size: 28px;\r\n}\r\n\r\n/* Tabs – matches MUI Tab styling with custom hover */\r\n.tabs {\r\n  display: flex;\r\n  gap: 10px;\r\n  margin-bottom: 30px;\r\n  background: white;\r\n  border-radius: 8px;\r\n  padding: 10px;\r\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n}\r\n\r\n.tabs button {\r\n  flex: 1;\r\n  padding: 12px 20px;\r\n  border: none;\r\n  background: none;\r\n  cursor: pointer;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: #666;\r\n  border-radius: 6px;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.tabs button:hover {\r\n  background-color: #f0f0f0;\r\n}\r\n\r\n.tabs button.active {\r\n  background-color: #1976d2;\r\n  color: white;\r\n}\r\n\r\n/* Content panels */\r\n.content {\r\n  background: white;\r\n  border-radius: 8px;\r\n  padding: 30px;\r\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\r\n}\r\n\r\n.tab-content h2 {\r\n  color: #1a365d;\r\n  margin-bottom: 25px;\r\n  padding-bottom: 10px;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n/* Form sections (Cards) */\r\n.form-section {\r\n  margin-bottom: 30px;\r\n  padding: 20px;\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 6px;\r\n  background-color: #fafafa;\r\n}\r\n\r\n.form-section h3 {\r\n  color: #1976d2;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n/* Grid layout helpers */\r\n.form-row {\r\n  display: flex;\r\n  gap: 20px;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.form-group {\r\n  flex: 1;\r\n}\r\n\r\n.form-group label {\r\n  display: block;\r\n  margin-bottom: 5px;\r\n  font-weight: 600;\r\n  color: #555;\r\n}\r\n\r\n.form-group input,\r\n.form-group select,\r\n.form-group textarea {\r\n  width: 100%;\r\n  padding: 10px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n}\r\n\r\n.form-group input:focus,\r\n.form-group select:focus,\r\n.form-group textarea:focus {\r\n  outline: none;\r\n  border-color: #1976d2;\r\n  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.2);\r\n}\r\n\r\n/* Tables – used for items / room details */\r\n.items-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  margin: 20px 0;\r\n}\r\n\r\n.items-table th,\r\n.items-table td {\r\n  padding: 12px;\r\n  text-align: left;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.items-table th {\r\n  background-color: #f8f9fa;\r\n  font-weight: 600;\r\n  color: #495057;\r\n}\r\n\r\n.items-table tr:hover {\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n.items-table input[type=\"number\"],\r\n.items-table input[type=\"text\"] {\r\n  width: 100%;\r\n  padding: 8px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n}\r\n\r\n/* Totals section (used in invoice, may be reused) */\r\n.total-section {\r\n  text-align: right;\r\n  margin-top: 20px;\r\n  padding: 15px;\r\n  background-color: #e3f2fd;\r\n  border-radius: 6px;\r\n}\r\n\r\n.total-section h3,\r\n.total-section h4 {\r\n  color: #0d47a1;\r\n  margin: 0;\r\n}\r\n\r\n/* Buttons */\r\n.btn-primary {\r\n  background-color: #1976d2;\r\n  color: white;\r\n  padding: 12px 30px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease;\r\n  display: block;\r\n  margin: 20px auto 0;\r\n}\r\n\r\n.btn-primary:hover {\r\n  background-color: #1565c0;\r\n}\r\n\r\n.btn-secondary {\r\n  background-color: #6c757d;\r\n  color: white;\r\n  padding: 10px 20px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.btn-secondary:hover {\r\n  background-color: #5a6268;\r\n}\r\n\r\n/* Search section (Tab 2) */\r\n.search-section {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.search-box {\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: center;\r\n}\r\n\r\n.search-box input {\r\n  flex: 1;\r\n}\r\n\r\n/* Invoice / Agreement detail view */\r\n.invoice-details {\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 8px;\r\n  padding: 25px;\r\n  background-color: #fff;\r\n}\r\n\r\n.invoice-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  margin-bottom: 30px;\r\n  padding-bottom: 20px;\r\n  border-bottom: 2px solid #1976d2;\r\n}\r\n\r\n.invoice-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 15px;\r\n}\r\n\r\n/* Status badges */\r\n.status-badge {\r\n  padding: 5px 10px;\r\n  border-radius: 20px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n}\r\n\r\n.status-badge.pending {\r\n  background-color: #fff3cd;\r\n  color: #856404;\r\n}\r\n\r\n.status-badge.paid {\r\n  background-color: #d4edda;\r\n  color: #155724;\r\n}\r\n\r\n.status-badge.active {\r\n  background-color: #cce5ff;\r\n  color: #004085;\r\n}\r\n\r\n.status-badge.expired {\r\n  background-color: #f8d7da;\r\n  color: #721c24;\r\n}\r\n\r\n/* Payment table (if reused) */\r\n.payment-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  margin-top: 15px;\r\n}\r\n\r\n.payment-table th,\r\n.payment-table td {\r\n  padding: 12px;\r\n  text-align: left;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.payment-table th {\r\n  background-color: #f8f9fa;\r\n  font-weight: 600;\r\n}\r\n\r\n/* Totals labels */\r\n.total-label {\r\n  text-align: right;\r\n  font-weight: 600;\r\n  font-size: 16px;\r\n}\r\n\r\n.total-amount {\r\n  font-weight: 700;\r\n  font-size: 18px;\r\n  color: #0d47a1;\r\n}\r\n\r\n/* Investor info block */\r\n.investor-info p {\r\n  margin-bottom: 8px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.investor-info strong {\r\n  display: inline-block;\r\n  width: 120px;\r\n  color: #555;\r\n}\r\n\r\n/* Edit form animation */\r\n.edit-form {\r\n  animation: slideIn 0.3s ease;\r\n}\r\n\r\n@keyframes slideIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(20px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n/* Responsive adjustments */\r\n@media (max-width: 768px) {\r\n  .form-row {\r\n    flex-direction: column;\r\n    gap: 15px;\r\n  }\r\n  \r\n  .invoice-header {\r\n    flex-direction: column;\r\n    gap: 15px;\r\n  }\r\n  \r\n  .search-box {\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .tabs {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .app {\r\n    padding: 12px;\r\n  }\r\n}\r\n\r\n/* Chip customization */\r\n.MuiChip-root {\r\n  font-weight: 500;\r\n}\r\n\r\n/* Card hover effect */\r\n.MuiCard-root {\r\n  transition: box-shadow 0.3s ease;\r\n}\r\n\r\n.MuiCard-root:hover {\r\n  box-shadow: 0 4px 12px rgba(0,0,0,0.1);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
